<template>
    <Head>
        <title>Биржи</title>
    </Head>

    <authenticated-layout>

        <template #header>
            <organization-navigation v-if="organizationId" :organization-id="organizationId"/>
        </template>

        <div class="flex flex-col bg-white p-6">
            <div class="flex flex-row justify-between">

                <h1 class="text-2xl pb-6">Биржи</h1>

                <span
                    v-if="this.$page.props.auth.permissions.exchanges.add"
                    @click="add.show = !add.show"
                    class="flex items-center text-green-400 hover:text-green-600 cursor-pointer gap-2"
                >
                    <svg
                        class="fill-current h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 16 16"
                    >
                        <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"/>
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>
                    Добавить
                </span>

            </div>

            <div class="col-span-full flex flex-row items-end gap-4" v-show="add.show || Object.keys(errors).length">
                <v-input v-model="add.group" label="Группа" :error="errors.group"/>
                <v-input v-model="add.type" label="Тип" :error="errors.type"/>
                <v-input v-model="add.alias" label="Описание" :error="errors.alias"/>
                <v-select v-model="add.useFor" label="Для" :error="errors.useFor">
                    <option v-for="i in useForList">{{ i }}</option>
                </v-select>
                <v-input v-model="add.publicKey" label="Публичный ключ" :error="errors.publicKey"/>
                <v-input v-model="add.privateKey" label="Приватный ключ" :error="errors.privateKey"/>
                <v-button color="green" @click="create">Сохранить</v-button>
            </div>

            <div class="grid grid-cols-7 p-2 gap-2 items-center font-bold">
                <span  class="col-span-2">id</span>
                <span>Группа</span>
                <span>Тип</span>
                <span>Для</span>
                <span>Описание</span>
            </div>

            <div v-for="row in result" class="grid grid-cols-7 border-t p-2 gap-2 items-center">
                <span class="col-span-2 text-sm">{{ row.id }}</span>
                <span>{{ row.group }}</span>
                <span>{{ row.type }}</span>
                <span>{{ row.useFor }}</span>
                <span>{{ row.alias }}</span>
                <div class="grid grid-cols-2 gap-2">
                    <v-button color="red" @click="removeId = row.id" v-if="this.$page.props.auth.permissions.exchanges.remove">Удалить</v-button>
                    <v-button @click="row.edit = !(row.edit || false)" v-if="this.$page.props.auth.permissions.exchanges.update">Править</v-button>
                </div>
                <div class="col-span-full flex flex-row items-end gap-4" v-show="row.edit || false">
                    <v-input v-model="row.group" label="Группа"/>
                    <v-input v-model="row.type" label="Тип"/>
                    <v-input v-model="row.alias" label="Описание"/>
                    <v-select v-model="row.useFor" label="Для">
                        <option v-for="i in useForList">{{ i }}</option>
                    </v-select>
                    <v-input v-model="row.publicKey" label="Публичный ключ"/>
                    <v-input v-model="row.privateKey" label="Приватный ключ"/>
                    <v-button color="green" @click="row.edit = false; update(row)">Обновить</v-button>
                </div>

            </div>

            <modal-confirm
                :showing="removeId !== false"
                @close="removeId = false"
                @submit="remove">
                Удалить?
                <pre class="text-left text-xs">{{ Object.values(result).filter((row) => row.id === removeId)[0] }}</pre>
            </modal-confirm>

        </div>


    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import OrganizationNavigation from "@/Components/Navigation/Organization";
import moment from "moment";
import VButton from "@/Components/Button";
import VInput from "@/Components/Input";
import VSelect from "@/Components/Select";
import ModalConfirm from "@/Components/ModalConfirm";

export default {
    components: {
        OrganizationNavigation,
        Head, Link,
        AuthenticatedLayout,
        VButton,
        VInput,
        VSelect,
        ModalConfirm,
    },
    props: {
        group: {
            type: String,
            default: '',
        },
        organizationId: String,
        result: Object,
        useForList: Array,
        errors: Object,
    },
    data() {
        return {
            add: {
                show: false,
                group: this.group || '',
                type: '',
                alias: '',
                useFor: this.useForList[0],
                publicKey: '',
                privateKey: '',
            },
            removeId: false,
        }
    },
    methods: {
        moment,
        create() {
            this.add.show = false;
            useForm(this.add).post(this.route('exchanges.store'));
        },
        update(exchange) {
            useForm(exchange).put(this.route('exchanges.update', exchange.id));
        },
        remove() {
            const id = this.removeId;
            this.removeId = false;
            useForm({}).delete(this.route('exchanges.destroy', id));
        },
    },
}
</script>
